<script setup lang="ts">
    import { onMounted, reactive } from 'vue';
    import { bsAlert, AlertTypes } from '@shared/components/BsAlerts';
    import { getServiceLevelPrices, ServiceLevelPriceTier } from './Pricing.access';

    const state = reactive<{
        tiers: ServiceLevelPriceTier[];
        loading: boolean;
    }>({
        tiers: [],
        loading: false,
    });

    onMounted(async () => {
        state.loading = true;
        try {
            state.tiers = await getServiceLevelPrices();
        } catch {
            bsAlert({ type: AlertTypes.Danger, title: 'Error', content: 'Failed to load pricing' });
        } finally {
            state.loading = false;
        }
    });
</script>

<template>
    <h1 class="main-title">Pricing</h1>

    <div v-if="state.loading">Loading...</div>
    <div v-else>
        <div v-for="tier in state.tiers" :key="tier.ServiceSubscriptionTier.Name" class="table-responsive">
            <table class="table table-hover table-sticky-headers">
                <thead>
                    <tr>
                        <th>
                            {{ tier.ServiceSubscriptionTier.Name }}
                            (version: {{ tier.ServiceSubscriptionTier.Version }})
                        </th>
                        <th
                            v-for="currency in tier.ServiceLevels[0]?.Currencies"
                            :key="currency.Currency.CurrencyCode"
                            class="text-right"
                            style="width: 120px">
                            {{ currency.Currency.CurrencyCode }}
                        </th>
                    </tr>
                </thead>
                <tbody class="td-align-middle">
                    <tr v-for="row in tier.ServiceLevels" :key="row.ServiceLevel.Name">
                        <td>
                            <span class="strong">{{ row.ServiceLevel.Name }}</span>
                        </td>
                        <td
                            v-for="(refCurrency, idx) in tier.ServiceLevels[0]?.Currencies"
                            :key="refCurrency.Currency.CurrencyCode"
                            class="text-right">
                            <template v-if="row.Currencies && row.Currencies[idx]">
                                {{ row.Currencies[idx].MonthlyPrice }}
                            </template>
                            <template v-else>-</template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
    export default {
        name: 'Pricing',
    };
</script>

<style></style>
